(function() {
    'use strict';
    angular
        .module('ccsTrApp')
        .factory('Growth', Growth);

    Growth.$inject = ['$resource'];

    function Growth ($resource) {
        var resourceUrl =  'api/growths/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
